import { render, staticRenderFns } from "./v-popper2.vue?vue&type=template&id=a9126002&scoped=true&"
import script from "./v-popper2.vue?vue&type=script&lang=js&"
export * from "./v-popper2.vue?vue&type=script&lang=js&"
import style0 from "./v-popper2.vue?vue&type=style&index=0&id=a9126002&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9126002",
  null
  
)

export default component.exports